import { createAsyncThunk } from '@reduxjs/toolkit';

import { BasicInfoHttpDeleteService } from 'Feature/Common/Common/Services/BasicInfoHttpService';
import { BasicInfoHttpGetService } from 'Feature/Common/Common/Services/BasicInfoHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import IDeleteReminderCommand from '../../../Common/types/Commands/IDeleteReminderCommand';

import { IGetRemindersByCurrentUserPagedQuery } from 'Feature/BasicInfo/Common/types/Queries/IGetRemindersByCurrentUserPagedQuery';

export const deleteReminder = createAsyncThunk('Reminder/deleteReminder', async (command: IDeleteReminderCommand) => {
  return await BasicInfoHttpDeleteService({
    url: `${_apiPathManagerConfig?.BasicInfo.Reminder.DeleteReminder}`,
    body: command,
    fromQuery: false,
  });
});

export const getSendingRemindersByCurrentUserPagedFilter = createAsyncThunk(
  'Reminder/getSendingRemindersByCurrentUserPagedFilter',
  async (query: IGetRemindersByCurrentUserPagedQuery) => {
    return await BasicInfoHttpGetService({
      url: `${_apiPathManagerConfig?.BasicInfo.Reminder.GetRemindersByCurrentUserPagedFilter}`,
      params: query,
    });
  }
);
